import Rete from "rete";
import { OperationSocket,OperationsControl } from "../rete-controls/OperationsControl.js"
import ReteComponentStore from "../ReteComponentStore.js"

export default class OperationsComponent extends Rete.Component {
    constructor(){
        super("Operation"); // name
        this._categories = ["Statistics Nodes", "tryMe"];
    }

    builder(node) {
        let out1 = new Rete.Output('out1','OP',OperationSocket);
        let opControl = new OperationsControl(this.editor,"op");

        return node
        .addOutput(out1)
        .addControl(opControl);
    }

    worker(node, inputs, outputs) {
        outputs['out1'] = node.data.op;

        //console.log(this.name + " node.data= " + JSON.stringify(node.data));
        //console.log(this.name + " outputs= " + JSON.stringify(outputs));
    }
}

//ReteComponentStore.add(new OperationsComponent())

